import CONF from 'config/conf.singleton';
import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import logger from 'utils/logger.util';
import actionBe from 'utils/mw/actionBe.util';
import isPositiveInteger from 'utils/predicates/number/isPositiveInteger.util';

const L = logger('beFeed');

const beFeed = actionBe('beFeed', ({ AT, ATAG, page: pageFromOptions }) => {
  L.debug('()', 'pageFromOptions:', pageFromOptions);

  const parsed = fromAnyToInteger(pageFromOptions);
  const isValid = isPositiveInteger(parsed);

  const page = isValid ? parsed : 1;
  if (!isValid) L.warn('()', 'Invalid pageFromOptions:', pageFromOptions, 'using page:', page);

  return endpoint(H.get, `feed/feed/:salonId/?page=:page`, {
    AT,
    name: ATAG,
    base: CONF.activityApiRoot,
    params: { page },
  });
});

export default beFeed;
